import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";
import { Snackbar, SnackbarContent } from "@material-ui/core";

//Deps
import classNames from "classnames";

//Icons
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import ErrorIcon from "@material-ui/icons/Error";
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from "@material-ui/icons/Info";
import WarningIcon from "@material-ui/icons/Warning";

//Colors
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";

const styles = theme => ({
  root: {},
  close: {
    width: theme.spacing.unit * 4,
    height: theme.spacing.unit * 4
  }
});

const iconStyles = theme => ({
  root: {},
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  icontype: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

//Icon
const typeIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

//Snackbar Builder
function MySnackbarContent(props) {
  /* 

  TODO: 
    ADD message, veriant INTO dispatcher TO CONTROL THIS FROM SAGAS

  */
  const { classes, className, message, onClose, type, ...other } = props;
  const Icon = typeIcon[type];

  return (
    <SnackbarContent
      className={classNames(classes[type], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.icontype)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}>
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  type: PropTypes.oneOf(["success", "warning", "error", "info"]).isRequired
};

const MySnackbarContentWrapper = withStyles(iconStyles)(MySnackbarContent);

class InfoSnackbar extends React.Component {
  render() {
    const { closeSnackbar, isOpen, message, type } = this.props;

    const handleClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      this.setState({ open: false });
      closeSnackbar();
    };

    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          open={isOpen}
          autoHideDuration={3000}
          onClose={handleClose}>
          <MySnackbarContentWrapper
            onClose={handleClose}
            type={type}
            message={message}
          />
        </Snackbar>
      </div>
    );
  }
}

InfoSnackbar.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(["success", "warning", "error", "info"]).isRequired
};

export default withStyles(styles)(InfoSnackbar);



// WEBPACK FOOTER //
// ./src/components/InfoSnackbar.js